<!-- =========================================================================================
    File Name: ForgotPassword.vue
    Description: FOrgot Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img">
    <div
      class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center"
    >
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div
              class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center"
            >
              <img
                src="@/assets/images/pages/forgot-password.png"
                alt="login"
                class="mx-auto"
              />
            </div>
            <div
              class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg"
            >
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">{{$t('RecoverYourPassword')}}</h4>
                  <p>
                    {{$t('RecoverYourPasswordInstuctions')}}
                  </p>
                </div>

                <vs-input
                  type="email"
                  :label-placeholder="$t('Email')"
                  v-model="email"
                  class="w-full mb-8"
                />
                <vs-button type="border"
                           to="/pages/login"
                           class="px-4 w-full md:w-auto">{{$t('BackToLogin')}}</vs-button>
                <vs-button class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0"
                           @click="submitResetPassword">{{$t('RecoverPassword')}}</vs-button>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import AccountsService from "@/accounts/accountsService.js";

export default {
  data() {
    return {
      email: ""
    };
  },
  methods: {
    submitResetPassword() {
      var instance = this;
      AccountsService.resetPassword(
        this.email,
        this.password,
        this.confirm,
        this.$route.query.pid,
        1
      ).then(function (response) {
        instance.$vs.notify({
          time: 8000,
          title: "Success",
          text: instance.$t('RecoverPasswordMessage'),
          color: "success",
          iconPack: "feather",
          icon: "icon-success-circle",
        });
      });
    },
  },
};
</script>
